import moment from 'moment';

export const formatDate = (value: string) => {
  if (value) {
    return moment(value).format('DD-MM-YYYY');
  }
};
